import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { with: String }

  connect() {
    // Sla originele inhoud op
    this.originalHTML = this.element.innerHTML

    // Luister naar turbo events om te resetten
    this.boundReset = this.reset.bind(this)
    document.addEventListener('turbo:submit-end', this.boundReset)

    // Luister naar invalid events op het formulier (front-end validatie)
    const formId = this.element.getAttribute('form')
    if (formId) {
      this.form = document.getElementById(formId)
    } else {
      this.form = this.element.closest('form')
    }

    if (this.form) {
      this.boundResetOnInvalid = this.reset.bind(this)
      this.form.addEventListener('invalid', this.boundResetOnInvalid, true)
    }
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.boundReset)
    if (this.form) {
      this.form.removeEventListener('invalid', this.boundResetOnInvalid, true)
    }
  }

  reset() {
    this.element.innerHTML = this.originalHTML
    delete this.element.dataset.disabled
  }

  // doesn't seem to work with input type="submit".
  // please use the button element instead.
  handle(event) {
    const element = event.target
    const disableWith = this.withValue

    if (element.dataset.disabled) {
      event.preventDefault()
    } else {
      element.dataset.disabled = true
      element.innerHTML = disableWith
    }
  }
}
